import React, { useState, useContext, useEffect } from "react"
import TabsFacultades from "../Utils/TabsFacultades"
import ListadoCohortes from "./ListadoCohortes"
import "../UAI.css"
import { UsuarioContext } from "../Context/Usuario"
import UAI from "../UAI"
import Loading from "../Utils/Loading"
import log from "loglevel"
import ListadoCohortesUI from "./ListadoCohortesUI"
import TituloVista from "../Utils/TituloVista"
import {
  Button,
  ButtonGroup,
  ToggleButton,
  ToggleButtonGroup,
} from "react-bootstrap"
import XLSX from "xlsx"
import { RiFileExcel2Line } from "react-icons/ri"
import { MdOutlineWrapText, MdRefresh, MdWrapText } from "react-icons/md"

const Cohortes = (props) => {
  const { usuario } = useContext(UsuarioContext)

  const [tabs, setTabs] = useState({
    facultad: null,
    unidadventa: null,
    columns: null,
  })
  const [reload, setReload] = useState(0)
  const [loading, setLoading] = useState(true)
  const [cohortes, setCohortes] = useState(null)
  const [fulltext, setFulltext] = useState(false)

  useEffect(() => {
    log.debug("UseEffect Cohortes.js")
    let _view = props.view
    if (typeof _view === "string") {
      _view = UAI.vistas[_view]
    }

    let atributos = UAI.atributosMinimos;
    atributos = atributos.concat(_view.fields);
    if (_view.fieldsRequired && _view.fieldsRequired.length > 0) {
      atributos = atributos.concat(_view.fieldsRequired);
    }
    setLoading(true);

    UAI.obtieneCohortesUsuario(
      usuario.username,
      usuario.periodo,
      atributos,
      true,
      true,
      (num) => {
        log.debug("Progress!" + num)
      },
      (result) => {
        // Filtramos los cohortes por facultad y unidad de venta
        let cohortesusuario = result[0].Cohortes.reduce((prev, current) => {
          prev.push(UAI.completaAtributosCohorte(current, usuario.periodo))
          return prev
        }, [])
        setCohortes(cohortesusuario)
        setLoading(false)
      },
      (error) => {
        log.error(error)
      }
    )
  }, [
    usuario,
    props.view,
    tabs.columns,
    tabs.facultad,
    tabs.unidadventa,
    reload,
  ])

  if (!props.view) {
    let _view = props.view
    if (typeof _view === "string") {
      _view = UAI.vistas[_view]
    }
    return <Loading message={"Cargando " + _view.title} />
  }

  const titulo = (
    <TituloVista
      title={
        "Cohortes " +
        usuario.periodo +
        ": Información " +
        props.view.subcategory +
        " " +
        props.view.title
      }
      vista={props.view}
      imprimir={true}
      botones={
        <>
          <Button
            variant={fulltext ? "outline-primary" : "primary"}
            title={
              fulltext
                ? "Mostrar atributos de texto abreviados"
                : "Mostrar atributos de texto completos"
            }
            onClick={(e) => {
              log.debug(e)
              setFulltext(!fulltext)
            }}
          >
            <MdOutlineWrapText />
          </Button>
          <Button
            variant="outline-primary"
            onClick={() => {
              setCohortes(null)
              setReload(reload + 1)
            }}
            title="Refrescar"
          >
            <MdRefresh />
          </Button>
          <Button
            variant="outline-primary"
            onClick={() => {
              // Elemento en el DOM que es la tabla que despliega. La usaremos para descargar el Excel con la información.
              let tbl = document.getElementById("table-" + props.view.key)
              if (!tbl) {
                throw new Error(
                  "No encontramos la tabla con ID table-" +
                    props.view.key +
                    " para poder descargar Excel."
                )
              }
              let wb = XLSX.utils.table_to_book(tbl)
              XLSX.writeFile(
                wb,
                "Cohortes-" +
                  tabs.facultad +
                  "-" +
                  tabs.unidadventa +
                  "-" +
                  props.view.key +
                  ".xlsx"
              )
            }}
            title="Descargar datos en Excel"
          >
            <RiFileExcel2Line />
          </Button>
        </>
      }
    />
  )

  if (!tabs.unidadventa || !tabs.facultad || !cohortes || loading) {
    return (
      <>
        {titulo}
        <TabsFacultades
          toggleTabs={setTabs}
          tipoColumnas="cohortes"
          view={props.view.key}
        ></TabsFacultades>
        <Loading />
      </>
    )
  }

  return (
    <>
      {titulo}
      <TabsFacultades
        toggleTabs={setTabs}
        tipoColumnas="cohortes"
        view={props.view.key}
        filtros={["coordinadorasadmision", "coordinadorasprogramas"]}
      ></TabsFacultades>
      {props.view.ui && (
        <ListadoCohortesUI tabs={tabs} view={props.view} cohortes={cohortes} />
      )}
      {!props.view.ui && (
        <ListadoCohortes
          tabs={tabs}
          view={props.view}
          cohortes={cohortes}
          fullvalue={fulltext}
        />
      )}
    </>
  )
}

export default Cohortes
